// streamingデータのtype
export const STREAMING_DATA_TYPES = {
  ERROR: 'error', // エラー
  RESULT: 'result', // 生成結果
  KEYWORDS_NOT_EXTRACTED: 'keywords_not_extracted', // キーワードが抽出されなかった
} as const;

// エラーメッセージ
export const ERROR_MSG_ERROR_OCCURRED = 'エラーが発生しました';
export const ERROR_MSG_FAILED_TO_GENERATE_RESPONSE = '回答生成に失敗しました';
export const ERROR_MSG_UNABLE_TO_GENERATE_RESPONSE =
  '現在こちらの回答を生成することができません';
export const ERROR_MSG_UNEXPECTED_ERROR_OCCURRED =
  '予期しないエラーが発生しました';
// エラー説明文
export const ERROR_DESC_RETRY = '申し訳ありませんが、再度お試しください';
export const ERROR_DESC_RETRY_LATER =
  '申し訳ありませんが、時間を空けて再度お試しください';
export const ERROR_DESC_MODIFY_REQUEST =
  '申し訳ありませんが、依頼文を変えてお試しください';
